import React, {PureComponent} from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import classnames from 'classnames';
import { PortalConfigContext } from '../../config/portal';
import { getCurrentRoutes as rts, getPathnameLanguage } from '../../utils/language';
import messages from '../../utils/translationMessages';
import { getAssetUrl, isMobileResolution } from '../../utils/commonHelper';
import { getCurrentLocale } from '../../utils/language';
import { generateSearchPath } from '../../utils/urlHelpers/boats';
import { generateBlogPath } from '../../utils/urlHelpers/blog';
import { generateSearchPath as generateEnginesSearchPath } from '../../utils/urlHelpers/engines';
import { setGenericEvent } from '../../store/actions/dataLayer';
import LanguagePicker from '../LanguagePicker';
import KeywordSearch from '../KeywordSearch';
import { getFSBOUrl } from '../../utils/urlHelpers/fsbo';
import './styles.css';

class Header extends PureComponent {

  state = {
    isMobileResolution: false,
    open: false
  }

  resizeHandler = () => {
    this.setState(
      {
        isMobileResolution: isMobileResolution()
      }
    );
  }

  trackGenericClick = (event) => () => {
    if (event) {
      this.props.setGenericEvent('navigation - header', event.action, event.label);
    }
  }

  generatePathFromRoute = (route) => {
    const routes = rts();

    if (typeof route === 'object' && route.search) {
      if (route.type === 'engine') {
        return generateEnginesSearchPath({}, route.search, true);
      }

      return generateSearchPath({}, route.search, true);
    }
    if (route && route.article) {
      return `${getPathnameLanguage()}${route.article}`;
    }
    if (route && route.blog) {
      return generateBlogPath(route.blog);
    }
    if (route && ['SELL_URL_ROOT', 'SELL_ENGINES_URL_ROOT'].indexOf(route) >= 0) {
      return getFSBOUrl(route);
    }
    return routes[route];
  }

  componentDidMount() {
    window.addEventListener('resize', this.resizeHandler);
    this.resizeHandler();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeHandler);
  }

  render() {
    let { isMobileResolution, open } = this.state;
    const { intl } = this.props;
    const { formatMessage: t } = intl;
    const currentLanguage = getCurrentLocale();
    const context = get(this, 'context', {});
    const supports = get(context, 'supports');
    const multiLanguage = get(supports, 'multiLanguage');
    const fsboCTA = get(supports, 'fsboCTA', true);
    const headerContext = get(context, 'header', {});
    const logo = get(context.languages[currentLanguage], 'alternativeAssets.header.logo', headerContext.logo);
    const headerLinks = get(headerContext, 'links', []);
    const sellBoatUrl = getFSBOUrl();
    const usesOldHeader = get(context, 'supports.oldHeader');
    const headerClassnames = classnames('page-header-container', {'new-header': !usesOldHeader});
    const keywordSearchOptions = get(headerContext, 'keywordSearchOptions' , null);

    return (
      <div className={headerClassnames}>
        <div className={classnames('page-header', { 'nav-open': open })}>
          <nav id="main-nav">
            <ul>
              {headerLinks.map(({
                name,
                route,
                links,
                event,
                languages }, index) =>{
                if (languages) {
                  if (!languages.includes(currentLanguage)) { return null; }
                }
                return <li key={index} className={classnames({'has-children': links })}>
                  <a href={this.generatePathFromRoute(route)} onClick={this.trackGenericClick(event)}>
                    {t(messages.header[name])}
                  </a>
                  {links && <ul className="drop-list">{links.map(({
                    name,
                    route,
                    event,
                    languages
                  }, index) => {
                    if (languages) {
                      if (!languages.includes(currentLanguage)) { return null; }
                    }
                    return <li key={index}>
                      <a href={this.generatePathFromRoute(route)}
                        onClick={this.trackGenericClick(event)}>{t(messages.header[name])}</a>
                    </li>;
                  })}</ul>}
                </li>;
              })}
            </ul>
          </nav>

          <header className="main nav-slide">
            <button onClick={() => this.toggleOpen()} className="navbar-toggle">
              <span className="visuallyhidden">{t(messages.header.toggle)}</span>
            </button>
            <a href={rts().HOME_URL_ROOT}><img className="logo" src={getAssetUrl(logo)} alt={context.fullName} /></a>
            <a href={rts().HOME_URL_ROOT}><img className="logo-mobile" src={getAssetUrl(headerContext.logoMobile || logo)} alt={context.fullName} /></a>
            <a href={rts().HOME_URL_ROOT}><img className="logo-nav" src={getAssetUrl(headerContext.logoNav || logo)} alt={context.fullName} /></a>
          </header>

          <div className="right-nav">
            {fsboCTA && <div className="cta-wrapper">
              <a
                className="nav-cta"
                href={sellBoatUrl}
                onClick={this.trackGenericClick({ action: 'sell your boat', label: 'sell your boat'})}>
                {'\uFF0B ' + t(messages.header.callToAction)}
              </a>
            </div> }
            { multiLanguage && <LanguagePicker /> }
            <div className="header-login">
              <div className="header-login-icon">
                <div className="header-login-head"></div>
                <div className="header-login-body"></div>
              </div>
              <div>Login</div>
            </div>
            { !isMobileResolution && headerContext.keywordSearch &&
              <div className="keyword-container-desktop"> <KeywordSearch intl={intl} keywordSearchOptions={keywordSearchOptions} /> </div>
            }
          </div>
          { isMobileResolution && headerContext.keywordSearch &&
            <div className="keyword-container-mobile"> <KeywordSearch intl={intl} keywordSearchOptions={keywordSearchOptions}/> </div>
          }
        </div>
      </div>
    );
  }

  toggleOpen(){
    this.setState({
      open: !this.state.open
    });
  }
}

Header.propTypes = {
  intl: PropTypes.shape({
    formatMessage: PropTypes.func.isRequired,
  }).isRequired,
  setGenericEvent: PropTypes.func.isRequired,
  appBannerHeight: PropTypes.number,
};

Header.contextType = PortalConfigContext;

export default connect(
  null,
  (dispatch) => bindActionCreators({
    setGenericEvent
  }, dispatch)
)(injectIntl(Header));
